/* Luzzart · PDP v4 (CRO): datas de entrega, barra de compra fixa, atalhos para a ficha e texto único de garantia. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

  // Feriados nacionais (fixos + Carnaval, Sexta-feira Santa e Corpus Christi), que não contam como dia útil.
  var FIXOS = ['1-1', '4-21', '5-1', '9-7', '10-12', '11-2', '11-15', '11-20', '12-25'];
  var moveis = {};
  function pascoa(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mes = Math.floor((h + l - 7 * m + 114) / 31), dia = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mes - 1, dia);
  }
  function feriadosMoveis(y) {
    if (moveis[y]) return moveis[y];
    var p = pascoa(y), out = {};
    [-48, -47, -2, 60].forEach(function (off) {
      var d = new Date(p.getFullYear(), p.getMonth(), p.getDate() + off);
      out[(d.getMonth() + 1) + '-' + d.getDate()] = true;
    });
    return (moveis[y] = out);
  }
  function isFeriado(d) {
    var k = (d.getMonth() + 1) + '-' + d.getDate();
    return FIXOS.indexOf(k) !== -1 || !!feriadosMoveis(d.getFullYear())[k];
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6 && !isFeriado(d)) added++;
    }
    return d;
  }

  function fmt(d) { return d.getDate() + ' de ' + MESES[d.getMonth()]; }

  // "Receba entre 6 e 13 de out, com rastreio"
  function setupEta() {
    document.querySelectorAll('[data-luz-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 7;
      var max = parseInt(el.getAttribute('data-max'), 10) || 12;
      var now = new Date();
      var a = addBusinessDays(now, min);
      var b = addBusinessDays(now, max);
      var range = a.getMonth() === b.getMonth() ? a.getDate() + ' e ' + fmt(b) : fmt(a) + ' e ' + fmt(b);
      // As datas já dizem o prazo; "7 a 12 dias úteis" fica no title, para quem quiser conferir.
      el.innerHTML = 'Receba entre <b>' + range + '</b>, com rastreio';
      el.title = min + ' a ' + max + ' dias úteis';
    });
  }

  // Deixa a linha "Garantia" da ficha técnica igual ao resto da página.
  function setupWarranty() {
    var src = document.querySelector('[data-luz-warranty]');
    var text = src ? src.getAttribute('data-luz-warranty') : '2 anos de garantia Luzzart';
    document.querySelectorAll('.custom-table tr, #technical-specifications tr').forEach(function (tr) {
      var th = tr.querySelector('th');
      var td = tr.querySelector('td');
      if (!th || !td) return;
      var k = th.textContent.replace(/[:?]/g, '').trim().toLowerCase();
      if (k === 'garantia') td.textContent = text;
    });
  }

  function smoothTo(el) {
    try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(); }
  }

  function setupScrollLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-luz-scroll]');
      if (!a) return;
      var id = (a.getAttribute('href') || '').replace('#', '');
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      smoothTo(target);
    });
  }

  // Abre a aba pedida (ex.: "Dimensões") da ficha técnica e rola até ela.
  function openSpecsTab(label) {
    var root = document.getElementById('technical-specifications');
    if (!root) return false;
    var tabsRoot = document.getElementById('PrSecTabs');
    if (tabsRoot) tabsRoot.classList.remove('luz-acc-closed');
    var wanted = (label || 'Especificações').toLowerCase();
    var nodes = root.querySelectorAll('button, a, [role="tab"], .pr-tabs-desktop__tab, .prtabAcr, summary, h2, h3');
    var hit = null;
    function pick(test) {
      for (var i = 0; i < nodes.length && !hit; i++) {
        var n = nodes[i];
        if (n.offsetParent === null) continue;
        if (test(n.textContent.replace(/\s+/g, ' ').trim().toLowerCase())) hit = n;
      }
    }
    pick(function (t) { return t === wanted; });
    if (!hit) pick(function (t) { return t.indexOf('especifica') === 0; });
    if (hit) {
      var active = hit.classList.contains('is-active') || hit.classList.contains('active') || hit.getAttribute('aria-selected') === 'true' || hit.getAttribute('aria-expanded') === 'true';
      if (!active) hit.click();
    }
    smoothTo(root);
    return true;
  }

  function setupSpecsLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-luz-specs]');
      if (!a) return;
      if (openSpecsTab(a.getAttribute('data-luz-specs'))) e.preventDefault();
    });
  }

  // Barra fixa no celular: aparece quando o botão principal sai da tela e usa o próprio botão do formulário.
  function setupSticky() {
    var bar = document.querySelector('[data-luz-sticky]');
    if (!bar) return;
    var form = document.querySelector('.pr_meta form[action*="/cart/add"]');
    var main = form && (form.querySelector('button[type="submit"][name="add"]') || form.querySelector('[type="submit"]'));
    if (!main || !('IntersectionObserver' in window)) { bar.parentNode.removeChild(bar); return; }

    var btn = bar.querySelector('[data-luz-sticky-btn]');
    var priceEl = bar.querySelector('[data-luz-sticky-price]');
    var instEl = bar.querySelector('[data-luz-sticky-inst]');
    var mq = window.matchMedia('(max-width: 989px)');
    var on = false;
    var mainVisible = true;

    function apply() {
      var next = !mainVisible && mq.matches;
      if (next === on) return;
      on = next;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('luz-sticky-on', on);
    }

    // Botão cortado na borda da tela conta como fora: a barra entra e o cobre com um botão inteiro.
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].intersectionRatio >= 0.99;
      apply();
    }, { threshold: [0, 0.99] }).observe(main);
    if (mq.addEventListener) mq.addEventListener('change', apply);

    btn.addEventListener('click', function () {
      if (main.disabled) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      main.click();
    });

    var varEl = bar.querySelector('[data-luz-sticky-var]');
    var pct = pixPercent();
    var n = parcelCount();

    function sync() {
      btn.disabled = !!main.disabled;
      btn.textContent = main.disabled ? 'Esgotado' : 'Adicionar ao carrinho';
      var cents = currentPriceCents();
      if (cents && priceEl) priceEl.textContent = brl(cents);
      if (cents && instEl) {
        instEl.textContent = pct > 0 ? 'ou ' + brl(Math.round(cents * (100 - pct) / 100)) + ' no Pix' : (n > 1 ? 'ou ' + n + 'x de ' + brl(Math.round(cents / n)) : '');
      }
      if (varEl) {
        var t = variantTitle();
        if (t) varEl.textContent = t;
      }
    }
    sync();
    var mo = new MutationObserver(sync);
    mo.observe(main, { attributes: true, attributeFilter: ['disabled'] });
    var priceBox = document.querySelector('.pr_meta .priceSingle');
    if (priceBox) mo.observe(priceBox, { childList: true, subtree: true, characterData: true });
    [].forEach.call(document.querySelectorAll('.pr_meta .swatch .slVariant'), function (el) {
      mo.observe(el, { childList: true, subtree: true, characterData: true });
    });
    var meta = document.querySelector('.pr_meta');
    if (meta) meta.addEventListener('change', function () { setTimeout(sync, 0); });
  }

  function variantTitle() {
    return [].map.call(document.querySelectorAll('.pr_meta .swatch .slVariant'), function (e) {
      return e.textContent.replace(/\s+/g, ' ').trim();
    }).filter(Boolean).join(' · ');
  }

  function pixPercent() {
    var box = document.querySelector('.luz-buy[data-luz-pix]');
    var pct = box ? parseInt(box.getAttribute('data-luz-pix'), 10) || 0 : 0;
    return pct > 0 && pct < 100 ? pct : 0;
  }

  function parcelCount() {
    var box = document.querySelector('.luz-buy[data-luz-parc]');
    return box ? parseInt(box.getAttribute('data-luz-parc'), 10) || 12 : 12;
  }

  function currentPriceCents() {
    var p = document.querySelector('.pr_meta .priceSingle .orpr');
    return toCents(p ? p.textContent : '');
  }

  // Parcela com arredondamento normal: o tema divide e arredonda para baixo (587 ÷ 12 aparecia como 48,91).
  // O tema recria as linhas ao trocar de variação (coluna de compra e barra fixa do desktop), então as duas são observadas.
  function setupParcelas() {
    var meta = document.querySelector('.pr_meta');
    if (!meta || !meta.querySelector('.infoParcelamento')) return;
    var n = parcelCount();
    var sticky = document.querySelector('.stickyCart');
    function fix() {
      var cents = currentPriceCents();
      if (!cents || n < 2) return;
      var nTxt = n + 'x';
      var want = brl(Math.round(cents / n));
      [].forEach.call(document.querySelectorAll('.pr_meta .infoParcelamento, .stickyCart .infoParcelamento'), function (info) {
        var strongs = info.querySelectorAll('strong');
        if (strongs.length < 2) return;
        if (strongs[0].textContent.trim() !== nTxt) strongs[0].textContent = nTxt;
        if (strongs[1].textContent.replace(/\s+/g, ' ').trim() !== want) strongs[1].textContent = want;
      });
    }
    fix();
    var mo = new MutationObserver(fix);
    mo.observe(meta, { childList: true, subtree: true, characterData: true });
    if (sticky) mo.observe(sticky, { childList: true, subtree: true, characterData: true });
  }

  // Sem ?variant= na URL, marca a variação cuja foto é a capa (data-luz-hero), para foto e escolha baterem.
  // Espera o JS do tema (carregado tarde) ligar as opções e nunca passa por cima de uma escolha do cliente.
  function setupHeroVariant() {
    var box = document.querySelector('.luz-buy[data-luz-hero]');
    if (!box || /[?&]variant=/.test(location.search)) return;
    var opts;
    try { opts = JSON.parse(box.getAttribute('data-luz-hero')); } catch (e) { return; }
    if (!opts || !opts.length) return;
    var touched = false;
    var meta = document.querySelector('.pr_meta');
    if (meta) meta.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.swatch, select')) touched = true; }, true);
    var tries = 0;
    (function wait() {
      if (touched) return;
      var $ = window.jQuery;
      var first = document.querySelector('.pr_meta .pvOpt0 .swatchInput');
      if (!first) return;
      var ev = $ && $._data ? ($._data(first, 'events') || {}) : {};
      if (!ev.change) { if (++tries < 450) setTimeout(wait, 200); return; }
      opts.forEach(function (val, i) {
        var inputs = document.querySelectorAll('.pr_meta .pvOpt' + i + ' .swatchInput');
        for (var k = 0; k < inputs.length; k++) {
          if (inputs[k].value === val) {
            if (!inputs[k].checked) $(inputs[k]).prop('checked', true).trigger('change');
            break;
          }
        }
      });
      // A troca leva a galeria até a foto da variação; a capa (da mesma cor) volta para a frente.
      setTimeout(function () {
        var thumb = document.querySelector('.pr_thumbs_item[data-slide="0"] a');
        var ev = thumb && $._data ? ($._data(thumb, 'events') || {}) : {};
        if (!touched && ev.click) thumb.click();
      }, 80);
    })();
  }

  // Barra fixa do desktop (do tema): o preço dela variava (cinza e sem parcela num produto, 3 linhas em outro).
  // Uma linha só, igual à coluna de compra: "de" riscado, preço, parcelas e Pix. O CSS esconde a linha do tema.
  function setupDeskStickyPrice() {
    var data = document.querySelector('.stickyCart .prdata');
    var priceBox = document.querySelector('.pr_meta .priceSingle');
    if (!data || !priceBox) return;
    var line = document.createElement('p');
    line.className = 'luz-stp';
    data.appendChild(line);
    var n = parcelCount();
    var pct = pixPercent();
    function upd() {
      var cents = currentPriceCents();
      if (!cents) return;
      var cmp = priceBox.querySelector('.compareprice_text');
      var cmpTxt = cmp && cmp.offsetParent !== null ? cmp.textContent.replace(/\s+/g, ' ').trim() : '';
      // "Frete grátis" também aqui: numa tela baixa a barra é o que aparece na primeira tela, e o bloco de garantias fica abaixo da dobra.
      var html = (cmpTxt ? '<s>' + cmpTxt + '</s>' : '') + '<b>' + brl(cents) + '</b>' +
        (n > 1 ? '<span>' + n + 'x de ' + brl(Math.round(cents / n)) + ' sem juros</span>' : '') +
        (pct > 0 ? '<span class="luz-stp__pix">' + brl(Math.round(cents * (100 - pct) / 100)) + ' no Pix</span>' : '') +
        '<span class="luz-stp__ship">Frete grátis</span>';
      if (line.innerHTML !== html) line.innerHTML = html;
    }
    upd();
    new MutationObserver(upd).observe(priceBox, { childList: true, subtree: true, characterData: true });
  }

  // Barra fixa do desktop: o tema só a mostra depois que a página passa do botão de compra. Numa tela baixa
  // (notebook 1366×768) o botão abre abaixo da dobra e a primeira tela ficava sem botão: a barra aparece
  // sempre que o botão estiver abaixo da parte visível. Acima dele, continua valendo a regra do tema.
  function setupDeskStickyEarly() {
    var bar = document.querySelector('.stickyCart');
    var main = document.querySelector('.pr_meta form[action*="/cart/add"] button[name="add"]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(min-width: 990px)');
    var below = false;
    function apply() { bar.classList.toggle('luz-stc-on', below && mq.matches); }
    new IntersectionObserver(function (entries) {
      var r = entries[0].boundingClientRect;
      below = entries[0].intersectionRatio < 0.99 && r.top > 0;
      apply();
    }, { threshold: [0, 0.99] }).observe(main);
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  // Ficha técnica: medidas no mesmo formato dos destaques ("21 cm x 35 cm" vira "21 × 35 cm") e unidades à brasileira
  // em todas as linhas ("3.7V/130mA" vira "3,7 V/130 mA", "400g" vira "400 g", "4-6h" vira "4 a 6 h").
  // Cada linha do valor é tratada à parte ("21 cm x 35 cm<br>Cabo: 1,5 m"); valores com outra marcação ficam como estão.
  function setupSpecFormat() {
    var re = /^([\d.,]+)\s*(?:cm)?\s*[x×]\s*([\d.,]+)\s*(?:cm)?(?:\s*[x×]\s*([\d.,]+)\s*(?:cm)?)?$/i;
    var U = 'mAh|mA|V|W|A|cm|mm|kg|g|m|h';
    function fmtUnits(t) {
      return t.replace(new RegExp('(\\d)\\.(\\d+)\\s*(' + U + ')\\b', 'g'), '$1,$2 $3')
        .replace(/(\d)\s*-\s*(\d+)\s*(h|min)\b/g, '$1 a $2 $3')
        .replace(new RegExp('(\\d)(' + U + ')\\b', 'g'), '$1 $2');
    }
    function fmtSize(t) {
      var m = /cm/i.test(t) && t.match(re);
      return m ? [m[1], m[2], m[3]].filter(Boolean).join(' × ') + ' cm' : fmtUnits(t).replace(/ de Fio\b/g, ' de fio');
    }
    document.querySelectorAll('#technical-specifications tr').forEach(function (tr) {
      var th = tr.querySelector('th');
      var td = tr.querySelector('td');
      if (!th || !td) return;
      if ([].some.call(td.children, function (c) { return c.tagName !== 'BR'; })) return;
      var size = /dimens|medida|tamanho/.test(th.textContent.toLowerCase());
      [].forEach.call(td.childNodes, function (node) {
        if (node.nodeType !== 3) return;
        var t = node.nodeValue.replace(/\s+/g, ' ').trim();
        if (!t) return;
        var out = size ? fmtSize(t) : fmtUnits(t);
        if (out !== t) node.nodeValue = out;
      });
    });
  }

  // Barra fixa do desktop (do tema): a miniatura começa com a foto da variação marcada, não com a capa.
  function setupStickyImage() {
    var box = document.querySelector('.luz-buy[data-luz-var-img]');
    var img = document.querySelector('.stickyCart .stickCtImg');
    if (!box || !img || box.hasAttribute('data-luz-hero')) return;
    img.src = box.getAttribute('data-luz-var-img');
  }

  // Contador do carrinho: o "0" em destaque com o carrinho vazio some; volta assim que entra um item.
  function setupCartCount() {
    [].forEach.call(document.querySelectorAll('.cartCount'), function (el) {
      function upd() { el.classList.toggle('luz-zero', el.textContent.trim() === '0'); }
      upd();
      new MutationObserver(upd).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  // Celular: as abas (Especificações, Dimensões, Descrição) começam fechadas. O tema sempre abre a primeira,
  // então ela só fica escondida (sem salto de página) até a pessoa tocar numa aba ou no link da ficha.
  function setupAccordionClosed() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var root = document.getElementById('PrSecTabs');
    if (!root || !root.querySelector('.prtabAcr')) return;
    root.classList.add('luz-acc-closed');
    root.addEventListener('click', function (e) {
      var h = e.target.closest && e.target.closest('.prtabAcr');
      if (!h || !root.classList.contains('luz-acc-closed')) return;
      root.classList.remove('luz-acc-closed');
      // Aba "aberta" pelo tema e só escondida: mostra, sem deixar o tema fechá-la.
      if (h.classList.contains('active')) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }

  // Ajuda para escolher a cor da luz, abaixo da opção "cor da luz" / "emissão de luz".
  function setupLightHint() {
    var sw = document.querySelectorAll('.pr_meta .swatch');
    for (var i = 0; i < sw.length; i++) {
      var head = ((sw[i].querySelector('.header') || {}).textContent || '').toLowerCase();
      if (head.indexOf('luz') === -1 && head.indexOf('emiss') === -1) continue;
      if (sw[i].querySelector('.luz-lighthint')) continue;
      var vals = [].map.call(sw[i].querySelectorAll('.swatch-element'), function (e) {
        return (e.getAttribute('data-value') || '').toLowerCase();
      }).join(' | ');
      var warm = /quente|amarel/.test(vals);
      var cold = /fri[oa]|branc/.test(vals.replace(/branc[ao] quente/g, ''));
      if (!warm || !cold) continue;
      var p = document.createElement('p');
      p.className = 'luz-lighthint';
      p.innerHTML = '<b>Quente</b>: amarelada e aconchegante, para quarto e sala. <b>Fria</b>: branca, para ler e trabalhar.';
      sw[i].appendChild(p);
    }
  }

  // Nome da opção sem o "Escolha": "Escolha a cor da luz: Branca Quente" vira "Cor da luz: Branca Quente".
  // Só na tela; o nome cadastrado (carrinho, pedido) não muda.
  function setupOptionLabels() {
    [].forEach.call(document.querySelectorAll('.pr_meta .swatch .header > span'), function (s) {
      var t = s.firstChild;
      if (!t || t.nodeType !== 3) return;
      var out = t.nodeValue.replace(/^(\s*)escolha\s+(?:a |o |as |os |seu |sua |um |uma )?/i, '$1');
      if (out === t.nodeValue) return;
      t.nodeValue = out.replace(/^(\s*)(\S)/, function (m, sp, c) { return sp + c.toUpperCase(); });
    });
  }

  // Cartão "Tamanho" (quando o produto tem desenho de medidas): leva a galeria até o desenho. No celular, rola até
  // a galeria. Sem o desenho na galeria, abre a aba Dimensões.
  function setupDrawingLink() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-luz-drawing]');
      if (!b) return;
      e.preventDefault();
      var thumb = document.querySelector('.pr_photoes .pr_thumbs_item a[data-img="' + b.getAttribute('data-luz-drawing') + '"]');
      var $ = window.jQuery;
      var ev = thumb && $ && $._data ? ($._data(thumb, 'events') || {}) : {};
      if (!thumb || !ev.click) { openSpecsTab('Dimensões'); return; }
      thumb.click();
      var gal = document.querySelector('.pr_photoes');
      var r = gal.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.5) smoothTo(gal);
    });
  }

  // Produtos de Natal: último dia de pedido que chega até 23/12 no prazo máximo (a partir de setembro).
  // A linha fica logo acima do preço, na primeira tela também no celular (abaixo dele, a barra fixa a cobria),
  // e fora do bloco de preço, que o tema refaz a cada troca de variação. O [data-luz-natal] do bloco de
  // garantias só informa o prazo e fica escondido.
  function setupNatalCutoff() {
    var el = document.querySelector('[data-luz-natal]');
    var priceBox = document.querySelector('.pr_meta .priceSingle');
    if (!el || !priceBox) return;
    var max = parseInt(el.getAttribute('data-max'), 10) || 12;
    var now = new Date();
    if (now.getMonth() < 8) return;
    var target = new Date(now.getFullYear(), 11, 23);
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var last = null;
    for (var i = 0; i < 100; i++) {
      if (addBusinessDays(d, max) <= target) last = new Date(d.getTime());
      else break;
      d.setDate(d.getDate() + 1);
    }
    if (!last) return;
    var line = document.createElement('p');
    line.className = 'luz-natal';
    // O texto vai num span só: no flex da linha, cada pedaço solto ganharia o espaço do gap.
    line.innerHTML = '<span>Peça até <b>' + fmt(last) + '</b> e receba antes do Natal</span>';
    priceBox.parentNode.insertBefore(line, priceBox);
  }

  // No desktop, a aba "Descrição" ficou curta (os blocos visuais viraram seção própria): abre "Especificações".
  // Produtos com "descrição prioritária" continuam na Descrição.
  function setupDesktopTabs() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    if (document.querySelector('.luz-buy[data-luz-desc-prio="true"]')) return;
    var root = document.getElementById('technical-specifications');
    if (!root) return;
    var tabs = root.querySelectorAll('.pr-tabs-desktop__tab');
    var specs = null;
    var active = null;
    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i].textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.indexOf('especifica') === 0) specs = tabs[i];
      if (tabs[i].classList.contains('is-active')) active = tabs[i];
      // Mesma ordem do celular: Descrição por último.
      if (/^descri/.test(t)) tabs[i].style.order = '99';
    }
    if (specs && active && active !== specs && /descri/.test(active.textContent.toLowerCase())) specs.click();
  }


  // Celular: a barra de busca grande do cabeçalho some (CSS) e entra um ícone de lupa, igual aos outros ícones.
  var SEARCH_SVG = '<svg class="at-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" aria-hidden="true" focusable="false"><path d="M252.9,234.1l-53.4-53.4c-3.1-3.1-7.5-4.3-11.5-3.4c16.3-18.7,26.2-43.2,26.2-69.9c0-58.9-47.9-106.8-106.8-106.8 S0.6,48.5,0.6,107.3s47.9,106.8,106.8,106.8c27.1,0,51.9-10.2,70.8-26.9c-0.8,4,0.4,8.3,3.5,11.4L235,252c2.5,2.5,5.7,3.7,8.9,3.7 c3.2,0,6.5-1.2,8.9-3.7C257.8,247.1,257.8,239.1,252.9,234.1z M107.3,193.9c-47.7,0-86.6-38.8-86.6-86.6s38.8-86.6,86.6-86.6 s86.6,38.8,86.6,86.6S155.1,193.9,107.3,193.9z"/></svg>';
  function setupHeaderSearch() {
    var cols = document.querySelectorAll('.icons-col');
    for (var i = 0; i < cols.length; i++) {
      var col = cols[i];
      if (col.querySelector('.searchIcn, .luz-search-ico')) continue;
      var a = document.createElement('a');
      a.className = 'hdicon searchIcn luz-search-ico';
      a.href = '/search';
      a.title = 'Buscar';
      a.setAttribute('aria-label', 'Buscar');
      a.innerHTML = SEARCH_SVG;
      col.insertBefore(a, col.firstChild);
    }
  }

  // Celular: "Como fica na sua casa" vira faixa de arrastar (CSS); aqui entram os pontinhos de posição.
  function setupVsDots() {
    var list = document.querySelector('.pdp-vs-section .pdp-vs__list');
    if (!list) return;
    var rows = list.querySelectorAll('.pdp-vs__row');
    if (rows.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'luz-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < rows.length; i++) dots.appendChild(document.createElement('span'));
    list.parentNode.insertBefore(dots, list.nextSibling);
    var spans = dots.children;
    var raf = 0;
    function update() {
      raf = 0;
      var idx = 0;
      if (list.scrollLeft >= list.scrollWidth - list.clientWidth - 2) idx = rows.length - 1;
      else {
        var base = list.getBoundingClientRect().left + parseFloat(getComputedStyle(list).paddingLeft || 0);
        var best = Infinity;
        for (var j = 0; j < rows.length; j++) {
          var dist = Math.abs(rows[j].getBoundingClientRect().left - base);
          if (dist < best) { best = dist; idx = j; }
        }
      }
      for (var k = 0; k < spans.length; k++) spans[k].className = k === idx ? 'is-on' : '';
    }
    list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }

  // Preço no Pix, quando a loja configura um desconto (data-luz-pix, em %). Acompanha a troca de variação.
  function toCents(txt) {
    var m = (txt || '').replace(/\s+/g, '').match(/([\d.]+),(\d{2})/);
    return m ? parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10) : 0;
  }
  function brl(cents) {
    var r = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + r + ',' + ('0' + (cents % 100)).slice(-2);
  }
  function setupPix() {
    var box = document.querySelector('.luz-buy[data-luz-pix]');
    var pct = box ? parseInt(box.getAttribute('data-luz-pix'), 10) || 0 : 0;
    if (pct <= 0 || pct >= 100) return;
    var priceBox = document.querySelector('.pr_meta .priceSingle');
    if (!priceBox) return;
    var line = document.createElement('p');
    line.className = 'luz-pix';
    // A troca de variação refaz o bloco de preço (theme.js troca o innerHTML) e leva a linha junto: ela volta para o lugar.
    function place() {
      var anchor = document.querySelector('.pr_meta .parcelatorProduct') || priceBox;
      anchor.parentNode.insertBefore(line, anchor.nextSibling);
    }
    place();
    function update() {
      if (!line.isConnected) place();
      var p = priceBox.querySelector('.orpr');
      var cents = toCents(p ? p.textContent : '');
      if (!cents) { line.hidden = true; return; }
      line.hidden = false;
      var html = 'ou <b>' + brl(Math.round(cents * (100 - pct) / 100)) + '</b> no Pix <span>' + pct + '% de desconto</span>';
      // Só grava se mudou: a linha pode ficar dentro do bloco observado e não pode realimentar o observador.
      if (line.innerHTML !== html) line.innerHTML = html;
    }
    update();
    new MutationObserver(update).observe(priceBox, { childList: true, subtree: true, characterData: true });
  }

  // Selo "Frete grátis" ao lado do preço: no celular a caixa de garantias fica uma tela abaixo e o letreiro do topo
  // alterna mensagens; no notebook sem a barra fixa, o frete ficava abaixo da dobra. Vale para todo o Brasil, então
  // não cita estados. Como a linha do Pix, volta para o lugar quando o tema refaz o bloco de preço.
  function setupShipChip() {
    var priceBox = document.querySelector('.pr_meta .priceSingle');
    if (!priceBox) return;
    var chip = document.createElement('span');
    chip.className = 'luz-ship';
    chip.textContent = 'Frete grátis';
    function group() {
      var p = priceBox.querySelector('.orpr');
      while (p && p.parentNode !== priceBox) p = p.parentNode;
      return p;
    }
    function place() {
      var g = group();
      if (g && g.nextSibling !== chip) priceBox.insertBefore(chip, g.nextSibling);
    }
    place();
    new MutationObserver(function () { if (!chip.isConnected || chip.previousSibling !== group()) place(); })
      .observe(priceBox, { childList: true });
  }

  ready(function () {
    setupHeaderSearch();
    setupVsDots();
    setupPix();
    setupShipChip();
    setupParcelas();
    setupOptionLabels();
    setupLightHint();
    setupHeroVariant();
    setupStickyImage();
    setupDeskStickyPrice();
    setupDeskStickyEarly();
    setupDrawingLink();
    setupSpecFormat();
    setupCartCount();
    setupAccordionClosed();
    setupEta();
    setupNatalCutoff();
    setupWarranty();
    setupScrollLinks();
    setupSpecsLinks();
    setupSticky();
  });

  // As abas têm script próprio, ligado no DOMContentLoaded: espera por ele antes de trocar a aba.
  var tabsDone = false;
  function runTabs() { if (tabsDone) return; tabsDone = true; setTimeout(setupDesktopTabs, 0); }
  if (document.readyState === 'complete') runTabs();
  else {
    document.addEventListener('DOMContentLoaded', runTabs);
    window.addEventListener('load', runTabs);
  }
})();
